import { Avatar, Flex, Typography } from 'antd';

const { Text } = Typography;

const AvatarBlock = ({ icon, size, text, children }) => {
  const renderChildren = () => {
    if (text && !children) {
      return (
        <Text type="secondary" className="info-window-text--secondary">
          {text}
        </Text>
      );
    }

    return children;
  };

  return (
    <Flex align="center" gap={4}>
      <Avatar src={icon} size={size} />
      {renderChildren()}
    </Flex>
  );
};

export default AvatarBlock;
